import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SEO from '../components/SEO';

const ROLES = [{ value: 'reader', label: 'Reader' }, { value: 'player', label: 'Player' }, { value: 'journalist', label: 'Journalist' }, { value: 'scout', label: 'Scout / Agent' }];

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', email: '', first_name: '', last_name: '', password: '', password2: '', role: 'reader', country: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const inputStyle = { width: '100%', padding: '0.65rem 1rem', border: '1px solid #e5e5e5', borderRadius: 8, fontFamily: 'sans-serif', fontSize: '0.9rem', outline: 'none' };

  const handleSubmit = async () => {
    setLoading(true); setError('');
    try {
      await register(form);
      navigate('/');
    } catch (err) {
      const data = err.response?.data;
      setError(data ? Object.values(data).flat().join(' ') : 'Registration failed.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ padding: '3rem 1.5rem', display: 'flex', justifyContent: 'center' }}>
      <SEO title="Join Pitch & Pen" description="Create a free account to write stories, discover talent and connect with African football's storytelling community." noindex />
      <div style={{ width: '100%', maxWidth: 480 }}>
        <h1 style={{ fontSize: '1.75rem', marginBottom: '0.5rem', textAlign: 'center' }}>Join Pitch & Pen</h1>
        <p style={{ textAlign: 'center', color: '#666', fontFamily: 'sans-serif', marginBottom: '2rem', fontSize: '0.9rem' }}>Tell your story. Discover talent. Advocate for players.</p>
        <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
          {ROLES.map(r => (
            <button key={r.value} onClick={() => set('role', r.value)} className="btn"
              style={{ flex: '1 1 100px', fontFamily: 'sans-serif', background: form.role === r.value ? '#1a6b45' : 'white', color: form.role === r.value ? 'white' : '#444', border: '1px solid #e5e5e5' }}>
              {r.label}
            </button>
          ))}
        </div>
        {error && <p style={{ background: '#fdecea', color: '#c0392b', padding: '0.75rem 1rem', borderRadius: 8, fontFamily: 'sans-serif', fontSize: '0.875rem', marginBottom: '1rem' }}>{error}</p>}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem', marginBottom: '0.75rem' }}>
          <input value={form.first_name} onChange={e => set('first_name', e.target.value)} placeholder="First name" style={inputStyle} />
          <input value={form.last_name} onChange={e => set('last_name', e.target.value)} placeholder="Last name" style={inputStyle} />
        </div>
        {['username', 'email', 'country'].map(k => (
          <input key={k} value={form[k]} onChange={e => set(k, e.target.value)} placeholder={k.charAt(0).toUpperCase() + k.slice(1)} style={{ ...inputStyle, marginBottom: '0.75rem' }} />
        ))}
        <input type="password" value={form.password} onChange={e => set('password', e.target.value)} placeholder="Password" style={{ ...inputStyle, marginBottom: '0.75rem' }} />
        <input type="password" value={form.password2} onChange={e => set('password2', e.target.value)} placeholder="Confirm password" style={{ ...inputStyle, marginBottom: '1.5rem' }} />
        <button onClick={handleSubmit} disabled={loading} className="btn btn-primary" style={{ width: '100%', padding: '0.75rem', fontFamily: 'sans-serif', fontSize: '0.95rem' }}>
          {loading ? 'Creating account…' : 'Create account'}
        </button>
        <p style={{ textAlign: 'center', fontFamily: 'sans-serif', fontSize: '0.875rem', marginTop: '1.5rem', color: '#666' }}>
          Already have an account? <Link to="/login" style={{ color: '#1a6b45' }}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}
